import { Link } from 'react-router-dom'
import { ArrowUpRight, BookOpen, FileText, PlayCircle } from 'lucide-react'
import GlassCard from '../components/GlassCard'
import Skeleton from '../components/Skeleton'

function iconFor(type) {
  if (type === 'VIDEO') return PlayCircle
  if (type === 'TEXT') return FileText
  return BookOpen
}

export default function LearningFeed({ posts, loading }) {
  const items = loading ? undefined : posts?.lasts
  const live = posts?.live

  return (
    <GlassCard className="flex flex-col gap-3 p-4 lg:flex-row lg:items-center lg:gap-4">
      <div className="flex shrink-0 items-center gap-2.5">
        <div
          className="flex h-8 w-8 items-center justify-center rounded-xl border"
          style={{
            background: 'var(--dash-icon-bg)',
            borderColor: 'var(--dash-border)',
          }}
        >
          <BookOpen size={13} style={{ color: 'var(--dash-text-soft)' }} />
        </div>
        <div className="lg:min-w-[120px]">
          <h3
            className="text-xs font-semibold"
            style={{ color: 'var(--dash-text)' }}
          >
            Aprenda a usar a Verboo
          </h3>
          {live && (
            <Link
              to={live.link}
              className="mt-0.5 inline-flex items-center gap-1.5 text-[10px] font-medium"
              style={{ color: 'var(--dash-danger)' }}
            >
              <span className="relative flex h-1.5 w-1.5">
                <span
                  className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
                  style={{ background: 'var(--dash-danger)' }}
                />
                <span
                  className="relative inline-flex h-1.5 w-1.5 rounded-full"
                  style={{ background: 'var(--dash-danger)' }}
                />
              </span>
              {live.title}
            </Link>
          )}
        </div>
      </div>

      <div
        className="hidden h-8 w-px lg:block"
        style={{ background: 'var(--dash-border)' }}
      />

      <div className="flex min-w-0 flex-1 flex-wrap gap-2">
        {!items &&
          Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-8 w-40" />
          ))}

        {items?.map((item, i) => {
          const Icon = iconFor(item.type)
          return (
            <a
              key={i}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex min-w-0 max-w-[260px] items-center gap-1.5 rounded-xl border px-2.5 py-1.5 text-[11px] font-medium transition-colors hover:bg-[var(--dash-surface-hover)]"
              style={{
                borderColor: 'var(--dash-border)',
                color: 'var(--dash-text-soft)',
              }}
            >
              <Icon
                size={11}
                className="shrink-0"
                style={{ color: 'var(--dash-text-muted)' }}
              />
              <span className="truncate">{item.title}</span>
              <ArrowUpRight
                size={10}
                className="shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                style={{ color: 'var(--dash-text-faint)' }}
              />
            </a>
          )
        })}
      </div>
    </GlassCard>
  )
}
